var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

/**
 * Initializes the three-six module.
 * @constructor
 * @param {Object} el - The three/six grid element.
 */
function ThreeSix(el) {
  this.el = el;
 	this.$el = $(el);

 	
 	var $text = this.$el.find('.square-cta__item-text');
 	var $content = $text.children('.js-square-cta-content');

 	$text.each(function() {
      if($text.is(':visible') && $(window).width() >=850 ) {
        $text.css('max-height', $content.outerHeight());
      }
	});

	$(window).resize(function () {
    if ($(window).width() < 850) {
          $text.css('max-height', '');
    }
    else if ($(window).width() >= 850) {
    	$text.css('max-height', $content.outerHeight());
    }
	});

    $('.square-cta__item-img, .square-cta__item-img .inner').on('click', function () {
        var link = $(this).parent().find('.square-cta__item-link');
        if (link) {
            window.location.href = link.attr('href');
        }
    });

    $('.square-cta__item').on('mouseenter', function () {
        $(this).addClass('is-focus');
    }).on('mouseleave', function () {
        $(this).removeClass('is-focus');
    });

    $('.square-cta__item a').on('focus', function () {
        $(this).closest('.square-cta__item').addClass('is-focus');
    }).on('focusout', function () {
        $(this).closest('.square-cta__item').removeClass('is-focus');
    });
}

module.exports = ThreeSix;

